/* eslint-disable compat/compat */
import helpers from './helpers';

export default (function () {
  return {
    init() {
      this.setLanguage();
      this.checkLanguage();
    },

    setLanguage() {
      const path = window.location.pathname;
      const activeLanguageDropdown = document.querySelectorAll('#language-selector');
      if (activeLanguageDropdown.length === 0) return;

      helpers.forEach(activeLanguageDropdown, (i, elem) => {
        elem.addEventListener('change', (e) => {
          const customUrlValue = e.target.value;

          const modifiedPath = path.replace(/(\/[^/]+|\/)/, `/${customUrlValue}`);
          sessionStorage.setItem('language', customUrlValue);
          window.location.pathname = modifiedPath;
        });
      });
    },

    checkLanguage() {
      window.addEventListener('DOMContentLoaded', () => {
        const activeLanguage = sessionStorage.getItem('language');
        const activeLanguageDropdown = document.getElementById('language-selector');

        if (!activeLanguageDropdown) return;

        if (activeLanguage !== null) {
          activeLanguageDropdown.customSelect.value = activeLanguage;
        }
      });
    },
  };
})();
